export enum AppSettingScopeNameEnum {
  app = 'app',
  user = 'user',
  tenant = 'tenant',
}
